<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         [selectable]="false"
         class="credential-stores-grid">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="main">
            <ng-template>
                <button [matTooltip]="'grid_action_add' | translate"
                        [uiAuthorize]="'Settings.Create'"
                        [uiClickTrack]="'Action: Add Credential Store'"
                        (click)="openModal()"
                        color="primary"
                        data-cy="credential-stores-add-button"
                        mat-mini-fab
                        type="button">
                    <mat-icon>add</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [primary]="true"
                    [title]="'credential_stores_grid_name' | translate"
                    property="name"
                    width="25%">
    </ui-grid-column>

    <ui-grid-column [sortable]="true"
                    [title]="'credential_stores_grid_type' | translate"
                    property="type"
                    width="25%">
        <ng-template let-entry="data">
            {{entry.type.value}}
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'credential_stores_grid_robot_default' | translate"
                    property="type"
                    width="25%">
        <ng-template let-entry="data">
            <ng-container *ngIf="entry.isRobotDefault; else unthicked">
                <mat-icon class="credential-store-default">check</mat-icon>
            </ng-container>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'credential_stores_grid_assets_default' | translate"
                    property="type"
                    width="25%">
        <ng-template let-entry="data">
            <ng-container *ngIf="entry.isAssetDefault; else unthicked">
                <mat-icon class="credential-store-default">check</mat-icon>
            </ng-container>
        </ng-template>
    </ui-grid-column>

    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">

            <button [matMenuTriggerFor]="menu"
                    [matTooltip]="'global_more_actions_tooltip' | translate"
                    mat-icon-button
                    data-cy="credential-stores-context-menu"
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button *ngIf="entry.type.genericType === CredentialStoreGenericType.SecureStore"
                        [disabled]="loadingModal$ | async"
                        [matTooltip]="'credential_stores_action_edit_tooltip' | translate"
                        [uiAuthorize]="'Settings.Edit'"
                        [uiClickTrack]="'Action: Grid: Edit'"
                        (click)="openModal(entry)"
                        mat-menu-item
                        data-cy="credential-stores-edit-button">
                    <mat-icon svgIcon="uipath:Edit"></mat-icon>
                    <span translate>credential_stores_action_edit</span>
                </button>
                <button [disabled]="entry.isRobotDefault"
                        (click)="setDefaultStore(entry, CredentialStoreResourceType.RobotCredential)"
                        mat-menu-item
                        data-cy="credential-stores-robot-default-button"
                        type="button">
                    <mat-icon svgIcon="uipath:robots"></mat-icon>
                    <span translate>credential_stores_action_set_robot_default</span>
                </button>
                <button [disabled]="entry.isAssetDefault"
                        (click)="setDefaultStore(entry, CredentialStoreResourceType.AssetCredential)"
                        mat-menu-item
                        data-cy="credential-stores-asset-default-button"
                        type="button">
                    <mat-icon svgIcon="uipath:assets"></mat-icon>
                    <span translate>credential_stores_action_set_asset_default</span>
                </button>
                <button [uiAuthorize]="'Settings.Delete'"
                        (click)="remove(entry)"
                        color="warn"
                        mat-menu-item
                        data-cy="credential-stores-delete-button"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete"></mat-icon>
                    <span translate>credential_stores_action_remove</span>
                </button>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>

    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>

<ng-template #unthicked>
    <mat-icon class="credential-store-not-default">close</mat-icon>
</ng-template>
